/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const SAVE_CROPPER_STATE = "SAVE_CROPPER_STATE";

export const SET_UGC_SIZE = "SET_UGC_SIZE";

export const SET_UGC_IMAGE = "SET_UGC_IMAGE";

export const SET_ACTIVE_UGC_COMPONENT = "SET_ACTIVE_UGC_COMPONENT";
export const CHANGE_UGC_ACTIVE_COMPONENT = "CHANGE_UGC_ACTIVE_COMPONENT";

export const UPDATE_PLACEMENT_VIEW_ORDER = "UPDATE_PLACEMENT_VIEW_ORDER";
export const RESET_PLACEMENT_VIEW_ORDER = "RESET_PLACEMENT_VIEW_ORDER";

export const DELETE_TEMP_COMPONENT_SWATCH = "DELETE_TEMP_COMPONENT_SWATCH";
export const OVERWRITE_UGC_COMPONENT = "OVERWRITE_UGC_COMPONENT";

export const CLEAR = "CLEAR";

export const ADD_UGC_COMPONENT = "ADD_UGC_COMPONENT";
export const SET_RECIPE = "SET_RECIPE";

export const GET_PRODUCT_IMAGES_BY_RECIPE = "GET_PRODUCT_IMAGES_BY_RECIPE";
export const GET_PRODUCT_IMAGES_BY_RECIPE_ID =
  "GET_PRODUCT_IMAGES_BY_RECIPE_ID";
export const GET_CONFIRM_IMAGES = "GET_CONFIRM_IMAGES";
export const SAVE_PRODUCT_IMAGES = "SAVE_PRODUCT_IMAGES";

export const REMOVE_ALMOST_DONE_VIEW = "REMOVE_ALMOST_DONE_VIEW";

export const SET_BACKGROUND = "SET_BACKGROUND";
export const DISABLE_BG = "DISABLE_BG";

export const SET_BUCKET_SIZE = "SET_BUCKET_SIZE";
export const SET_TEMP_BUCKET_SIZE = "SET_TEMP_BUCKET_SIZE";
export const SET_RECIPE_FOR_DELETION = "SET_RECIPE_FOR_DELETION";

export const SET_STORE_MULTIPLE_UGC_SIZES = "SET_STORE_MULTIPLE_UGC_SIZES";

export const SET_PLACEMENT_VIEW_ORDER = "SET_PLACEMENT_VIEW_ORDER";
export const SET_UGC_FLOW_VIEWS = "SET_UGC_FLOW_VIEWS";
export const SET_UGC_FLOW_COMPONENTS = "SET_UGC_FLOW_COMPONENTS";

export const CLEAR_ORIGINAL_IMAGE = "CLEAR_ORIGINAL_IMAGE";

export const SAVE_STATE_MANAGERS = "SAVE_STATE_MANAGERS";

export const SET_UPLOAD_ANOTHER = "SET_UPLOAD_ANOTHER";

export const SET_SCALE_X = "SET_SCALE_X";
export const IS_REPLACE_TOOL = "IS_REPLACE_TOOL";

export const SET_UGC_FEATURE = "SET_UGC_FEATURE";

export const UPDATE_COMPONENT = "UPDATE_COMPONENT";
export const SET_REPLACE_COMPONENT_FEATURE = "SET_REPLACE_COMPONENT_FEATURE";
export const SET_APPLY_UGC_COMPONENTS= "SET_APPLY_UGC_COMPONENTS";
export const REMOVE_APPLY_UGC_COMPONENTS= "REMOVE_APPLY_UGC_COMPONENTS";

export const SET_ACTIVE_UGC_INDEX = "SET_ACTIVE_UGC_INDEX";
export const SET_SELECT_ANOTHER = "SET_SELECT_ANOTHER";
export const HAS_FINISHED_APPLYING = "HAS_FINISHED_APPLYING";

export const SET_CONTINUE_EDIT_FLOW = "SET_CONTINUE_EDIT_FLOW";
